export default __webpack_public_path__ + "static/fa-brands-400-70150a2b3a50f84aff707541dc66edf7.ttf";